export enum NeedleworkType{
    knitting,
    crochet,
    other,
}